import { typography } from '@shared/tokens/typography.stylex';
import * as stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  base: {
    position: 'relative',
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    ':not(#__unused__) > div': {
      width: '100% !important',
    },
    ':not(#__unused__) input': {
      fontSize: typography['fontSizeCaption-1'],
      paddingRight: '36px',
    },
  },
  iconButton: {
    position: 'absolute',
    right: 0,
    top: 0,
    bottom: 0,
    width: '36px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1,
  },
  searchIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    color: 'inherit',
  },
  crossIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    color: 'inherit',
  },
  hidden: {
    display: 'none',
  },
});
